var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade acm-wrapper",
      attrs: {
        id: "acmModal",
        "data-toggle": "modal",
        tabindex: "-1",
        role: "dialog",
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-lg acm-tooltip modal-dialog-centered",
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content acm-container container" }, [
            _c(
              "div",
              { staticClass: "modal-header title" },
              [
                _c("font-awesome-icon", { attrs: { icon: "cog" } }),
                _c("h4", { staticClass: "col-10" }, [
                  _vm._v(" " + _vm._s(_vm.$t("acm")) + " "),
                ]),
                _vm._m(0),
              ],
              1
            ),
            _c("div", { staticClass: "modal-body pt-3" }, [
              _c("div", { staticClass: "row pt-3" }, [
                _c("div", { staticClass: "acm-donut col-6" }, [
                  _c("div", { staticClass: "donut-size" }, [
                    _c("div", { staticClass: "pie-acm" }, [
                      _vm.acmDonutStyles[_vm.ACM_TOOLTIP_DONUT]
                        ? _c(
                            "svg",
                            {
                              staticClass: "donut",
                              attrs: {
                                width: "100%",
                                height: "100%",
                                viewBox: "5 5 32 32",
                              },
                            },
                            [
                              _c("circle", {
                                staticClass: "donut-hole",
                                attrs: {
                                  cx: "21",
                                  cy: "21",
                                  r: "15.91549430918954",
                                  fill: "#f3f5f7",
                                },
                              }),
                              _c("circle", {
                                staticClass: "donut-ring",
                                attrs: {
                                  cx: "21",
                                  cy: "21",
                                  r: "15.91549430918954",
                                  fill: "transparent",
                                  stroke: "#d2d3d4",
                                },
                              }),
                              _c("circle", {
                                staticClass: "alert_severities1 donut-segment",
                                attrs: {
                                  "stroke-dashoffset":
                                    _vm.acmDonutStyles[_vm.ACM_TOOLTIP_DONUT][
                                      _vm.ACMHelper.SEVERITY1
                                    ][_vm.ACMHelper.STROKE_DASHOFFSET],
                                  "stroke-dasharray":
                                    _vm.acmDonutStyles[_vm.ACM_TOOLTIP_DONUT][
                                      _vm.ACMHelper.SEVERITY1
                                    ][_vm.ACMHelper.STROKE_DASHARRAY],
                                  cx: "21",
                                  cy: "21",
                                  r: "15.91549430918954",
                                  fill: "transparent",
                                },
                              }),
                              _c("circle", {
                                staticClass: "alert_severities2 donut-segment",
                                attrs: {
                                  "stroke-dashoffset":
                                    _vm.acmDonutStyles[_vm.ACM_TOOLTIP_DONUT][
                                      _vm.ACMHelper.SEVERITY2
                                    ][_vm.ACMHelper.STROKE_DASHOFFSET],
                                  "stroke-dasharray":
                                    _vm.acmDonutStyles[_vm.ACM_TOOLTIP_DONUT][
                                      _vm.ACMHelper.SEVERITY2
                                    ][_vm.ACMHelper.STROKE_DASHARRAY],
                                  cx: "21",
                                  cy: "21",
                                  r: "15.91549430918954",
                                  fill: "transparent",
                                },
                              }),
                              _c("circle", {
                                staticClass: "alert_severities3 donut-segment",
                                attrs: {
                                  "stroke-dashoffset":
                                    _vm.acmDonutStyles[_vm.ACM_TOOLTIP_DONUT][
                                      _vm.ACMHelper.SEVERITY3
                                    ][_vm.ACMHelper.STROKE_DASHOFFSET],
                                  "stroke-dasharray":
                                    _vm.acmDonutStyles[_vm.ACM_TOOLTIP_DONUT][
                                      _vm.ACMHelper.SEVERITY3
                                    ][_vm.ACMHelper.STROKE_DASHARRAY],
                                  cx: "21",
                                  cy: "21",
                                  r: "15.91549430918954",
                                  fill: "transparent",
                                },
                              }),
                              _c("circle", {
                                staticClass: "alert_severities4 donut-segment",
                                attrs: {
                                  "stroke-dashoffset":
                                    _vm.acmDonutStyles[_vm.ACM_TOOLTIP_DONUT][
                                      _vm.ACMHelper.SEVERITY4
                                    ][_vm.ACMHelper.STROKE_DASHOFFSET],
                                  "stroke-dasharray":
                                    _vm.acmDonutStyles[_vm.ACM_TOOLTIP_DONUT][
                                      _vm.ACMHelper.SEVERITY4
                                    ][_vm.ACMHelper.STROKE_DASHARRAY],
                                  cx: "21",
                                  cy: "21",
                                  r: "15.91549430918954",
                                  fill: "transparent",
                                },
                              }),
                              _c("circle", {
                                staticClass: "alert_severities5 donut-segment",
                                attrs: {
                                  "stroke-dashoffset":
                                    _vm.acmDonutStyles[_vm.ACM_TOOLTIP_DONUT][
                                      _vm.ACMHelper.SEVERITY5
                                    ][_vm.ACMHelper.STROKE_DASHOFFSET],
                                  "stroke-dasharray":
                                    _vm.acmDonutStyles[_vm.ACM_TOOLTIP_DONUT][
                                      _vm.ACMHelper.SEVERITY5
                                    ][_vm.ACMHelper.STROKE_DASHARRAY],
                                  cx: "21",
                                  cy: "21",
                                  r: "15.91549430918954",
                                  fill: "transparent",
                                },
                              }),
                              _c("circle", {
                                staticClass: "alert_severities6 donut-segment",
                                attrs: {
                                  "stroke-dashoffset":
                                    _vm.acmDonutStyles[_vm.ACM_TOOLTIP_DONUT][
                                      _vm.ACMHelper.SEVERITY6
                                    ][_vm.ACMHelper.STROKE_DASHOFFSET],
                                  "stroke-dasharray":
                                    _vm.acmDonutStyles[_vm.ACM_TOOLTIP_DONUT][
                                      _vm.ACMHelper.SEVERITY6
                                    ][_vm.ACMHelper.STROKE_DASHARRAY],
                                  cx: "21",
                                  cy: "21",
                                  r: "15.91549430918954",
                                  fill: "transparent",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "label" }, [
                        _c("span", [_vm._v(_vm._s(_vm.$t("alertSeverities")))]),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "col-6" }, [
                  _c("div", { staticClass: "col-12 feedback-row" }, [
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-primary label-feedback",
                        on: {
                          click: function ($event) {
                            return _vm.setRequiresFeedbackFilter()
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.acm.numberAlertsRequireFeedback) +
                            " " +
                            _vm._s(_vm.$t("requireFeedback")) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "col-12 feedback-row" }, [
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-success label-feedback",
                        on: {
                          click: function ($event) {
                            return _vm.setFeedbackReceivedFilter()
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.acm.numberAlertsFeedbackReceived) +
                            " " +
                            _vm._s(_vm.$t("feedbackReceived")) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "col-12 feedback-row" }, [
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-secondary label-feedback",
                        on: {
                          click: function ($event) {
                            return _vm.setAcknowledgedFilters()
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.acm.numberAlertsAcknoledged) +
                            " " +
                            _vm._s(_vm.$t("acknowledged")) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "row pt-4" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchInput,
                        expression: "searchInput",
                      },
                    ],
                    staticClass: "col-12 form-control",
                    attrs: {
                      type: "text",
                      placeholder:
                        _vm.$t("filter") +
                        " " +
                        _vm.filteredAlerts.length +
                        " " +
                        _vm.$t("alerts"),
                    },
                    domProps: { value: _vm.searchInput },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchInput = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "row pt-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-6",
                    attrs: { id: "filterPopupContainer" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-12 form-control filter-status",
                        on: {
                          click: function ($event) {
                            _vm.alertStatusOpen = !_vm.alertStatusOpen
                          },
                        },
                      },
                      [
                        _vm.numberAlertStatusesFiltered === 0
                          ? [
                              _vm._v(
                                " " + _vm._s(_vm.$t("filterAlertStatus")) + " "
                              ),
                            ]
                          : _vm._e(),
                        _vm.numberAlertStatusesFiltered > 0
                          ? [
                              _c(
                                "div",
                                { staticClass: "badge badge-primary" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.alertStatusFilter[
                                          _vm.indexFirstAlertStatusSelected
                                        ].label
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.removeFilter(
                                            _vm.alertStatusFilter[
                                              _vm.indexFirstAlertStatusSelected
                                            ].value
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: {
                                          icon: "times",
                                          width: "5px",
                                          height: "5px",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm.numberAlertStatusesFiltered > 1
                                ? _c(
                                    "span",
                                    { staticClass: "float-right pr-3" },
                                    [
                                      _vm._v(
                                        "+ " +
                                          _vm._s(
                                            _vm.numberAlertStatusesFiltered - 1
                                          )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.alertStatusOpen,
                              expression: "alertStatusOpen",
                            },
                          ],
                          staticClass: "filter-status-tooltip",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "border-bottom col-12 pt-2 pb-2" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "container",
                                  on: {
                                    change: function ($event) {
                                      return _vm.toggleStatusSelects()
                                    },
                                  },
                                },
                                [
                                  !_vm.alertStatusSelectAll
                                    ? _c("span", [
                                        _vm._v(_vm._s(_vm.$t("selectAll"))),
                                      ])
                                    : _vm._e(),
                                  _vm.alertStatusSelectAll
                                    ? _c("span", [
                                        _vm._v(_vm._s(_vm.$t("unselectAll"))),
                                      ])
                                    : _vm._e(),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.alertStatusSelectAll,
                                        expression: "alertStatusSelectAll",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.alertStatusSelectAll
                                      )
                                        ? _vm._i(
                                            _vm.alertStatusSelectAll,
                                            null
                                          ) > -1
                                        : _vm.alertStatusSelectAll,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.alertStatusSelectAll,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.alertStatusSelectAll =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.alertStatusSelectAll = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.alertStatusSelectAll = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _c("span", { staticClass: "checkmark" }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "border-bottom col-12 search-alerts",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.searchInputAlertStatus,
                                    expression: "searchInputAlertStatus",
                                  },
                                ],
                                staticClass: "col-12 form-control",
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t("search"),
                                },
                                domProps: { value: _vm.searchInputAlertStatus },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.searchInputAlertStatus =
                                      $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "pt-2" },
                            [
                              _vm._l(
                                _vm.alertStatusFilterFiltered,
                                function (filter) {
                                  return _c(
                                    "div",
                                    {
                                      key: filter.label,
                                      staticClass: "col-12 alert-status",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "container" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(filter.label) + " "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: filter.model,
                                                expression: "filter.model",
                                              },
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                filter.model
                                              )
                                                ? _vm._i(filter.model, null) >
                                                  -1
                                                : filter.model,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a = filter.model,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          filter,
                                                          "model",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          filter,
                                                          "model",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      filter,
                                                      "model",
                                                      $$c
                                                    )
                                                  }
                                                },
                                                function ($event) {
                                                  return _vm.alertStatusFilterChanged()
                                                },
                                              ],
                                            },
                                          }),
                                          _c("span", {
                                            staticClass: "checkmark",
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm.alertStatusFilterFiltered.length === 0
                                ? _c("div", { staticClass: "col-12 col-12" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("noItemsToShow")) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "col-6 pl-0 viewMode" }, [
                  _c("div", { staticClass: "float-right" }, [
                    _c(
                      "label",
                      {
                        staticClass: "blue-lbl",
                        class: [
                          { checked: _vm.viewModeValue === "detailedView" },
                        ],
                        attrs: { for: "detailedView" },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.viewModeValue,
                              expression: "viewModeValue",
                            },
                          ],
                          attrs: {
                            type: "radio",
                            id: "detailedView",
                            name: "viewModeValue",
                            value: "detailedView",
                          },
                          domProps: {
                            checked: _vm._q(_vm.viewModeValue, "detailedView"),
                          },
                          on: {
                            change: function ($event) {
                              _vm.viewModeValue = "detailedView"
                            },
                          },
                        }),
                        _vm._v(" " + _vm._s(_vm.$t("detailedView")) + " "),
                      ]
                    ),
                    _c(
                      "label",
                      {
                        staticClass: "blue-lbl",
                        class: [{ checked: _vm.viewModeValue === "shortView" }],
                        attrs: { for: "shortView" },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.viewModeValue,
                              expression: "viewModeValue",
                            },
                          ],
                          attrs: {
                            type: "radio",
                            id: "shortView",
                            name: "viewModeValue",
                            value: "shortView",
                          },
                          domProps: {
                            checked: _vm._q(_vm.viewModeValue, "shortView"),
                          },
                          on: {
                            change: function ($event) {
                              _vm.viewModeValue = "shortView"
                            },
                          },
                        }),
                        _vm._v(" " + _vm._s(_vm.$t("shortView")) + " "),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "row pt-3 pb-3 alert-list" },
                [
                  _vm._l(_vm.filteredAlerts, function (alert, index) {
                    var _obj
                    return _c("div", { key: index, staticClass: "col-12" }, [
                      _c("div", { staticClass: "alert-item" }, [
                        _c("div", {
                          class: [
                            ((_obj = {}),
                            (_obj["alert-severity-" + alert.severity] = true),
                            _obj),
                            "alert-severity float-left",
                          ],
                        }),
                        _vm.viewModeValue === "shortView"
                          ? _c(
                              "div",
                              { staticClass: "alert-text float-left" },
                              [
                                _c("p", { staticClass: "name" }, [
                                  _vm._v(" " + _vm._s(alert.name) + " "),
                                  _c(
                                    "span",
                                    { class: [alert.statusClass, "badge"] },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t(alert.statusDescription))
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm.viewModeValue === "detailedView"
                          ? _c(
                              "div",
                              { staticClass: "alert-text float-left" },
                              [
                                _c("p", { staticClass: "name" }, [
                                  _c("b", [_vm._v(_vm._s(alert.name))]),
                                  _c(
                                    "span",
                                    { class: [alert.statusClass, "badge"] },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t(alert.statusDescription))
                                      ),
                                    ]
                                  ),
                                ]),
                                alert.details.summary.length > 0
                                  ? _c("div", { staticClass: "pt-1" }, [
                                      _c("b", [
                                        _vm._v(_vm._s(_vm.$t("summary")) + " "),
                                      ]),
                                      _c("span", [
                                        _vm._v(_vm._s(alert.details.summary)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                alert.details.recommendation.length > 0
                                  ? _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.$t("recommendation")) + " "
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(alert.details.recommendation)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                alert.details.feedback.length > 0
                                  ? _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.$t("feedback")) + " "
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(_vm._s(alert.details.feedback)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "float-right pt-2 small-text",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("created")) +
                                        " " +
                                        _vm._s(alert.details.created) +
                                        " / " +
                                        _vm._s(_vm.$t("updated")) +
                                        " " +
                                        _vm._s(alert.details.updated) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "spacer" }),
                      ]),
                    ])
                  }),
                  _vm.filteredAlerts.length === 0
                    ? _c("div", { staticClass: "col-12" }, [
                        _vm._v(" " + _vm._s(_vm.$t("noItemsToShow")) + " "),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: { type: "button", "data-dismiss": "modal" },
      },
      [_c("span", [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }